{
  "name": "retterseismo-frontend",
  "version": "26.3.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/platform-server": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@angular/ssr": "^18.2.0",
    "@ng-bootstrap/ng-bootstrap": "^17.0.1",
    "@ngx-translate/core": "^16.0.4",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.3.2",
    "chart.js": "^4.4.7",
    "crypto-js": "^4.2.0",
    "jquery": "^3.7.1",
    "ng2-charts": "^7.0.0",
    "ngx-toastr": "^19.0.0",
    "prismjs": "^1.29.0",
    "rxjs": "~7.8.0",
    "secure-web-storage": "^1.0.2",
    "simplebar-angular": "^3.3.0",
    "sweetalert2": "^11.15.9",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.12",
    "@angular/cli": "^18.2.12",
    "@angular/compiler-cli": "^18.2.0",
    "@angular/localize": "^18.2.0",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.5.2"
  }
}
